<template>
  <div id="app">
    <router-view/>
    <MiniProgramModal ref="miniModal" />
  </div>
</template>

<script>
import MiniProgramModal from '@/components/MiniProgramModal.vue'
import { eventBus } from '@/utils/eventBus'

export default {
  name: 'App',
  components: { MiniProgramModal },
  mounted() {
    eventBus.$on('show-mini-program', () => {
      this.$refs.miniModal.show()
    })
  },
  beforeDestroy() {
    eventBus.$off('show-mini-program')
  }
}
</script>

<style>
</style>
